import { Client } from "@/v2/types";
import ArFilterCombobox from "../../ui/combo-box/FilterComboBox";
import FindAllClient from "@/v2/api/client/FindAll";

interface ClientFilterComboBoxProps {
    value?: string; // The selected employee ID
    onChange?: (employeeId: string) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function ClientFilterComboBox({
    value,
    onChange,
    placeholder = "Select client...",
    disabled = false,
    className,
    label = "Client",
}: ClientFilterComboBoxProps) {
    const handleSelect = (item: Client | null) => {
        if (onChange) {
            onChange(item ? item.id : "");
        }
    };

    const renderEmployeeItem = (client: Client) => (
        <div className="flex flex-col">
            <span>{client.full_name}</span>
            {client.short_code && (
                <span className="text-xs text-muted-foreground">
                    {client.short_code}
                </span>
            )}
        </div>
    );

    return (
        <ArFilterCombobox<Client>
            label={label}
            labelAlign="items-start"
            queryKey={["clients"]}
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllClient({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(client: Client) => client.full_name}
            renderItem={renderEmployeeItem}
            placeholder={placeholder}
            searchPlaceholder="Search clients..."
            className={className}
            disabled={disabled}
            onItemSelect={handleSelect}
            defaultValueId={value}
            pageSize={20}
            debounceMs={300}
        />
    );
}
